import styled from 'styled-components';

export const Wrapper = styled.div`
  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  }
`;
